/* eslint-disable max-classes-per-file */
import { ObjectUtils } from "~app/common/utils/object-utils";

export class ListSorting {
    private fieldInternal: string;
    private reverseInternal: boolean;

    get field(): string {
        return this.fieldInternal;
    }

    set field(value: string) {
        this.fieldInternal = value;
    }

    get reverse(): boolean {
        return this.reverseInternal;
    }

    set reverse(value: boolean) {
        this.reverseInternal = value;
    }

    constructor(
        field: string,
        reverse: boolean) {
        this.fieldInternal = field;
        this.reverseInternal = reverse;
    }
}

export class ListState {
    private sortingInternal: ListSorting;
    private selectedInternal: string;

    get selected(): string {
        return this.selectedInternal;
    }

    set selected(value: string) {
        this.selectedInternal = value;
    }

    get sorting(): ListSorting {
        return this.sortingInternal;
    }

    set sorting(value: ListSorting) {
        this.sortingInternal = value;
    }

    constructor(
        sorting?: ListSorting) {
        this.sortingInternal = sorting;
        if (ObjectUtils.isNullOrUndefined(this.sortingInternal)) {
            this.sortingInternal = new ListSorting("", null);
        }
    }
}
